export default {
    "show-invoice": "Mostrar factura",
    "show-order": "Mostrar pedido",
    'invoice-updated-successfully': 'Factura actualizada con éxito'
}